/**
 * @Author: Zewei
 * @Date:   2018-02-01T10:34:25+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-27T16:56:22+08:00
 */
 import { Employee } from '../constants/employee-constants.js';

 const initState = {
  myAttendance: {
    filters: {},
    data: [],
    dataStatus: "unload"
  }
}

 export default function employee (state = initState, action) {
   switch (action.type) {
      // employee home
      case Employee.ActionTypes.FETCHEMPLOYEETIPSSUCCESS:
          return {...state, ...action.payload};
      case Employee.ActionTypes.FETCHEMPLOYEEIMPORTANTTIPSSUCCESS:
          return {...state, ...action.payload};
      // 申请中心
      case Employee.ActionTypes.FETCHLEAVETYPESSUCCESS:
          return {...state, ...action.payload};
      case Employee.ActionTypes.FETCHAPPLICATIONLISTSSUCCESS:
          return {...state, ...action.payload};
      //个人中心
      case Employee.ActionTypes.FETCHPERSONALCENTERSSUCCESS:
          return {...state, ...action.payload};
      //我的薪资
      case Employee.ActionTypes.FETCHMYSALARYSSUCCESS:
          return {...state, ...action.payload};
      //我的考勤详情
      case Employee.ActionTypes.FETCHMYATTENDANCEDETAILSUCCESS:
      return {
        ...state,
        myAttendance: {
          ...state.myAttendance,
          data: action.payload.data,
          dataStatus: "loaded"
        }
      }
      //移动端我的考勤
      case Employee.ActionTypes.FETCHMYATTENDANCESSUCCESS:
          return {...state, ...action.payload};
       // 默认 输出
      default:
          return {...state};
   }
 }



// WEBPACK FOOTER //
// ./src/reducers/employee-reducer.js